import React from "react";
import { 
  FaGraduationCap, 
  FaBook, 
  FaUsers, 
  FaTrophy,
  FaStar,
  FaAward,
  FaFlask,
  FaPills,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaCalendarAlt,
  FaCheckCircle
} from "react-icons/fa";
import { 
  MdSchool, 
  MdVerified,
  MdHealthAndSafety,
  MdLocationOn
} from "react-icons/md";
import { GiNurseFemale, GiMedicalPack } from "react-icons/gi";
import { BiCertification } from "react-icons/bi";

const UniversitySection = () => {
  return (
    <section className="py-16 px-4 bg-gradient-to-br from-slate-50 via-white to-slate-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-100 text-blue-700 text-sm font-semibold">
              <MdSchool className="text-lg" />
              The Institute
            </span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-blue-700 to-green-600 bg-clip-text text-transparent">
           R.D.S. NURSING &  PARAMEDICAL COLLEGE
            </span>
          </h2>
          
          <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
            Established in 1998 | Jaunpur, Uttar Pradesh | NAAC A+ Grade
          </p>
        </div>
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-200 mb-8">
          <div className="h-2 bg-gradient-to-r from-blue-600 to-green-600"></div>
          <div className="p-8 lg:p-10">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-10">
              <div className="text-center bg-gradient-to-b from-blue-50 to-white p-4 rounded-xl">
                <p className="text-4xl font-bold text-blue-600">25+</p>
                <p className="text-sm text-gray-600">Years of Excellence</p>
              </div>
              <div className="text-center bg-gradient-to-b from-green-50 to-white p-4 rounded-xl">
                <p className="text-4xl font-bold text-green-600">5000+</p>
                <p className="text-sm text-gray-600">Alumni Network</p>
              </div>
              <div className="text-center bg-gradient-to-b from-blue-50 to-white p-4 rounded-xl">
                <p className="text-4xl font-bold text-blue-600">50+</p>
                <p className="text-sm text-gray-600">Expert Faculty</p>
              </div>
              <div className="text-center bg-gradient-to-b from-green-50 to-white p-4 rounded-xl">
                <p className="text-4xl font-bold text-green-600">100%</p>
                <p className="text-sm text-gray-600">Placement Assistance</p>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div className="space-y-6">
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <FaGraduationCap className="text-blue-600" />
                    About the Institute
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    R.D.S. NURSING & PARAMEDICAL COLLEGE is one of the premier institutions in Eastern Uttar Pradesh 
                    dedicated to healthcare education. With over 25 years of excellence, we have produced thousands 
                    of skilled nurses and pharmacists who are serving in top healthcare institutions across India and abroad.
                  </p>
                </div>

                <div className="bg-gradient-to-r from-blue-50 to-green-50 p-6 rounded-2xl">
                  <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <FaAward className="text-blue-600" />
                    Accreditations & Recognitions
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div className="flex items-center gap-2 bg-white p-2 rounded-lg">
                      <BiCertification className="text-blue-600 text-xl" />
                      <span className="text-sm text-gray-700">Indian Nursing Council (INC)</span>
                    </div>
                    <div className="flex items-center gap-2 bg-white p-2 rounded-lg">
                      <FaStar className="text-blue-600 text-xl" />
                      <span className="text-sm text-gray-700">NAAC A+ Grade</span>
                    </div>
                    <div className="flex items-center gap-2 bg-white p-2 rounded-lg">
                      <MdVerified className="text-green-600 text-xl" />
                      <span className="text-sm text-gray-700">GNM affiliated UP state medical faculty</span>
                    </div>
                      <div className="flex items-center gap-2 bg-white p-2 rounded-lg">
                      <MdVerified className="text-green-600 text-xl" />
                      <span className="text-sm text-gray-700">BSc nursing affiliated atal Bihari Vajpayee medical University</span>
                    </div>
                      <div className="flex items-center gap-2 bg-white p-2 rounded-lg">
                      <MdVerified className="text-green-600 text-xl" />
                      <span className="text-sm text-gray-700">GNM College code 1537</span>
                    </div>
                    <div className="flex items-center gap-2 bg-white p-2 rounded-lg">
                      <MdVerified className="text-green-600 text-xl" />
                      <span className="text-sm text-gray-700">BSc nursing college code 2220387</span>
                    </div>

                  </div>
                </div>
              </div>
              <div className="space-y-6">
                <div className="bg-gray-50 p-6 rounded-2xl">
                  <h3 className="text-xl font-bold text-gray-800 mb-4">Contact Information</h3>
                  
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <FaMapMarkerAlt className="text-blue-600" />
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800">Address</p>
                        <p className="text-sm text-gray-600">
                          Village - Kushnow, Post - Bhaupur<br />
                          District - Jaunpur, Pin - 222136<br />
                          Uttar Pradesh
                        </p>
                      </div>
                    </div>
                    
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <FaPhone className="text-green-600" />
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800">Call Us</p>
                        <p className="text-sm text-gray-600">+917607094014 (Admission)</p>
                        <p className="text-sm text-gray-600">+91 8127918114 (General)</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <FaEnvelope className="text-blue-600" />
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800">Email</p>
                        <p className="text-sm text-gray-600">rdsnursing@gmail.com</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4">Programs Offered</h3>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium">B.Sc. Nursing</span>
                    <span className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-medium">GNM</span>
                    <span className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-medium">D.Pharma</span>
                    <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium">B.Pharma</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <h3 className="text-xl font-bold text-gray-800 mb-6">Campus Highlights</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-white border border-gray-100 rounded-xl p-4 text-center hover:shadow-md transition-shadow">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
                    <FaBook className="text-blue-600 text-xl" />
                  </div>
                  <p className="font-semibold text-sm">Modern Library</p>
                  <p className="text-xs text-gray-500">5000+ Books</p>
                </div>
                <div className="bg-white border border-gray-100 rounded-xl p-4 text-center hover:shadow-md transition-shadow">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2">
                    <GiMedicalPack className="text-green-600 text-xl" />
                  </div>
                  <p className="font-semibold text-sm">Advanced Labs</p>
                  <p className="text-xs text-gray-500">Well-equipped</p>
                </div>
                <div className="bg-white border border-gray-100 rounded-xl p-4 text-center hover:shadow-md transition-shadow">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
                    <MdHealthAndSafety className="text-blue-600 text-xl" />
                  </div>
                  <p className="font-semibold text-sm">Teaching Hospital</p>
                  <p className="text-xs text-gray-500">200+ Beds</p>
                </div>
                <div className="bg-white border border-gray-100 rounded-xl p-4 text-center hover:shadow-md transition-shadow">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2">
                    <FaUsers className="text-green-600 text-xl" />
                  </div>
                  <p className="font-semibold text-sm">Hostel Facilities</p>
                  <p className="text-xs text-gray-500">Boys & Girls</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center">
          <button className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-blue-600 to-green-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-green-700 transition-all duration-300 shadow-lg">
            <FaGraduationCap />
            Download Institute Brochure
          </button>
        </div>
      </div>
    </section>
  );
};

export default UniversitySection;